export enum EchoEvents {
   BatchJobStarted = '.BatchJobStarted',
   BatchJobUpdated = '.BatchJobUpdated',
   BatchJobDone = '.BatchJobDone',
}
